import {
  PAYABLE_GROUP_REPORT,
  PAYABLE_REPORT,
  PAYABLE_PREVIEW,
} from '@portal/actions/actionTypes';
import {
  GetPayableAction,
  GetPayableGroupAction,
  GetPayablePreviewAction,
} from '@portal/actions/payable';

const initialState: reducers.PayableReducer = {
  payableGroupsReport: [],
  payableReport: [],
  countPayableGroup: 0,
  countPayable: 0,
  payablePreview: null,
};

const payableReducer = (
  state = initialState,
  action: GetPayableAction | GetPayableGroupAction | GetPayablePreviewAction
) => {
  const { type, payload } = action;
  switch (type) {
    case PAYABLE_REPORT:
      if (typeof payload === 'number' || !payload || 'total' in payload) {
        return state;
      }
      state = {
        ...state,
        payableReport: payload.rows as models.Payable[],
        countPayable: payload.count,
      };

      break;

    case PAYABLE_GROUP_REPORT:
      if (typeof payload === 'number' || !payload || 'total' in payload) {
        return state;
      }
      state = {
        ...state,
        payableGroupsReport: payload.rows as models.PayableGroup[],
        countPayableGroup: payload.count,
      };
      break;

    case PAYABLE_PREVIEW:
      if (
        typeof payload === 'number' ||
        Array.isArray(payload) ||
        (payload && !('total' in payload))
      ) {
        return state;
      }
      state = {
        ...state,
        payablePreview: payload,
      };
      break;

    default:
      return state;
  }

  return state;
};

export default payableReducer;
